import { frontendURL } from '../../../helper/URLHelper';

import GenelBakis from './MetaAdsGenelBakis.vue';
import Reklamlar from './MetaAdsReklamlar.vue';
import Kampanyalar from './MetaAdsKampanyalar.vue';
import ReklamSetleri from './MetaAdsReklamSetleri.vue';
import ReklamListesi from './MetaAdsReklamListesi.vue';
import Otomasyonlar from './MetaAdsOtomasyonlar.vue';
import ABTestleri from './MetaAdsABTestleri.vue';
import Kutuphane from './MetaAdsKutuphane.vue';
import Kreatifler from './MetaAdsKreatifler.vue';
import Medya from './MetaAdsMedya.vue';
import Formlar from './MetaAdsFormlar.vue';
import ReklamKutuphanesi from './MetaAdsReklamKutuphanesi.vue';
import HedefKitleler from './MetaAdsHedefKitleler.vue';
import Kitleler from './MetaAdsKitleler.vue';
import Hedefleme from './MetaAdsHedefleme.vue';
import Istatistikler from './MetaAdsIstatistikler.vue';
import Performans from './MetaAdsPerformans.vue';
import Raporlar from './MetaAdsRaporlar.vue';
import PotansiyelMusteriler from './MetaAdsPotansiyelMusteriler.vue';
import Donusumler from './MetaAdsDonusumler.vue';
import Ayarlar from './MetaAdsAyarlar.vue';
import Baglantilar from './MetaAdsBaglantilar.vue';
import Isletme from './MetaAdsIsletme.vue';
import Takip from './MetaAdsTakip.vue';
import MarkaGuvenligi from './MetaAdsMarkaGuvenligi.vue';
import WhatsAppAraclari from './MetaAdsWhatsAppAraclari.vue';

// Reklam yonetimi yalnizca yoneticiye acik: kampanya durdurmak/baslatmak para
// harcamasini etkiler, temsilci yetkisinde olmamali.
const YETKI = { permissions: ['administrator'] };

// Ust bolume girildiginde ilk sekmeye yonlendirilir; bos kabuk gosterilmez.
const ilkSekmeye = (rota) => ({ name: rota });

export const routes = [
  {
    path: frontendURL('accounts/:accountId/meta-ads'),
    name: 'meta_ads_genel_bakis',
    component: GenelBakis,
    meta: YETKI,
  },
  {
    path: frontendURL('accounts/:accountId/meta-ads/reklamlar'),
    component: Reklamlar,
    meta: YETKI,
    redirect: () => ilkSekmeye('meta_ads_kampanyalar'),
    children: [
      { path: 'kampanyalar', name: 'meta_ads_kampanyalar', component: Kampanyalar, meta: YETKI },
      { path: 'reklam-setleri', name: 'meta_ads_reklam_setleri', component: ReklamSetleri, meta: YETKI },
      { path: 'reklamlar', name: 'meta_ads_reklam_listesi', component: ReklamListesi, meta: YETKI },
      { path: 'otomasyonlar', name: 'meta_ads_otomasyonlar', component: Otomasyonlar, meta: YETKI },
      { path: 'ab-testleri', name: 'meta_ads_ab_testleri', component: ABTestleri, meta: YETKI },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/meta-ads/kutuphane'),
    component: Kutuphane,
    meta: YETKI,
    redirect: () => ilkSekmeye('meta_ads_kreatifler'),
    children: [
      { path: 'kreatifler', name: 'meta_ads_kreatifler', component: Kreatifler, meta: YETKI },
      { path: 'medya', name: 'meta_ads_medya', component: Medya, meta: YETKI },
      { path: 'formlar', name: 'meta_ads_formlar', component: Formlar, meta: YETKI },
      {
        path: 'reklam-kutuphanesi',
        name: 'meta_ads_reklam_kutuphanesi',
        component: ReklamKutuphanesi,
        meta: YETKI,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/meta-ads/hedef-kitleler'),
    component: HedefKitleler,
    meta: YETKI,
    redirect: () => ilkSekmeye('meta_ads_kitleler'),
    children: [
      { path: 'kitleler', name: 'meta_ads_kitleler', component: Kitleler, meta: YETKI },
      { path: 'hedefleme', name: 'meta_ads_hedefleme', component: Hedefleme, meta: YETKI },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/meta-ads/istatistikler'),
    component: Istatistikler,
    meta: YETKI,
    redirect: () => ilkSekmeye('meta_ads_performans'),
    children: [
      { path: 'performans', name: 'meta_ads_performans', component: Performans, meta: YETKI },
      { path: 'raporlar', name: 'meta_ads_raporlar', component: Raporlar, meta: YETKI },
      {
        path: 'potansiyel-musteriler',
        name: 'meta_ads_potansiyel_musteriler',
        component: PotansiyelMusteriler,
        meta: YETKI,
      },
      { path: 'donusumler', name: 'meta_ads_donusumler', component: Donusumler, meta: YETKI },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/meta-ads/ayarlar'),
    component: Ayarlar,
    meta: YETKI,
    redirect: () => ilkSekmeye('meta_ads_baglantilar'),
    children: [
      { path: 'baglantilar', name: 'meta_ads_baglantilar', component: Baglantilar, meta: YETKI },
      { path: 'isletme', name: 'meta_ads_isletme', component: Isletme, meta: YETKI },
      { path: 'takip', name: 'meta_ads_takip', component: Takip, meta: YETKI },
      {
        path: 'marka-guvenligi',
        name: 'meta_ads_marka_guvenligi',
        component: MarkaGuvenligi,
        meta: YETKI,
      },
      {
        path: 'whatsapp-araclari',
        name: 'meta_ads_whatsapp_araclari',
        component: WhatsAppAraclari,
        meta: YETKI,
      },
    ],
  },
];
